<template>
  <div>
    <h3>Repair Document</h3>
    <danger class="warning-message" title="Warning">
      Rebuilding the document metadata is a potentially destructive operation.
      Please ensure you have a backup of your document before proceeding.
    </danger>
    <div class="rebuild-button-container">
      <button type="button" class="btn btn-primary" @click="rebuildClicked">
        Repair Document
      </button>
    </div>
    <div class="outcome">
      <p v-if="outcome === 0" class="success">Document rebuilt successfully.</p>
      <p v-if="outcome === 1" class="fail">Unable to rebuild the document.</p>
    </div>
  </div>
</template>
<script>
import Danger from "@/components/common/banners/Danger.vue";
import documentModel from "@/mixins/documentModel";
import rebuilder from "@/services/word/documentModelRebuilder";

export default {
  components: { Danger },
  mixins: [documentModel],
  data: function () {
    return {
      outcome: -1,
    };
  },
  methods: {
    rebuildClicked: async function () {
      this.logDebug("Starting metadata rebuild.");
      this.outcome = -1;

      try {
        const model = this.documentModel;
        const newModel = await rebuilder.rebuild(model);
        this.logDebug("Document model rebuilt.", { oldModel: model, newModel });

        if (newModel) {
          this.saveDocumentModel(newModel);
          this.logDebug("Document model saved.", newModel);
        }

        this.outcome = 0;
        this.logInfo("Document metadata rebuilt.");
      } catch (error) {
        this.outcome = 1;
        this.logError("Error rebuilding document metadata.", { error });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/_css/variables";

.warning-message {
  margin-top: 10px;
}

.rebuild-button-container {
  display: flex;
  justify-content: center;
}

.outcome {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  font-weight: bold;

  & > .success {
    color: $green;
  }

  & > .fail {
    color: $red;
  }
}
</style>
